import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { StoryblokVoucherCardButtonCopy } from './StoryblokVoucherCardButtonCopy'

interface Props {
  promoCode?: string
  text: string
}

export const StoryblokVoucherCardDiscountBadge: FC<Props> = ({
  promoCode,
  text,
}) => {
  return (
    <div className="flex size-40 max-h-40 max-w-40 shrink-0 flex-col items-center justify-center rounded-full bg-light-tertiary">
      <span className="font-mono text-3xl font-medium">{text}</span>
      {promoCode ? (
        <div className="flex max-w-full flex-col gap-1">
          <div className="rounded-full bg-light-primary-medium p-3 text-center text-xs font-bold uppercase italic">
            {promoCode}
          </div>
          <StoryblokVoucherCardButtonCopy
            className="border-dark-primary-max text-dark-primary-max"
            size="small"
            textToCopy={promoCode}
            variant="outlined"
          >
            <FormattedMessage id="voucherBox.input.shortLabel.button" />
          </StoryblokVoucherCardButtonCopy>
        </div>
      ) : null}
    </div>
  )
}
